import { render, staticRenderFns } from "./GuildList.vue?vue&type=template&id=19043196&"
import script from "./GuildList.vue?vue&type=script&lang=js&"
export * from "./GuildList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports